
function reverseString (string) {
    
   return string.split('').reverse().join('');

}
$(document).ready(function() {
    $('.person-info .email > a').text( reverseString($('.person-info .email > a').text()));
    $('.person-info .tel--mobile > a').text( reverseString($('.person-info .tel--mobile > a').text())); 
    $('.person-info .tel--phone > a').text( reverseString($('.person-info .tel--phone > a').text())); 

});
define("obfuscateContactInfo", function(){});

